import React, { useState, useEffect } from "react";
import { Typography, Spin } from "antd";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import COLORS from "../../Style/colors";
import { Table } from "ant-table-extensions";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { BsPlus } from "react-icons/bs";
import CustomButton from "../../Components/CustomButton";
import { setQuestionsAction } from "../../redux/reducers/questionsReducer";
import openNotification from "../../Components/Notifications";
import { getQuestions } from "../../API/fetch";
import dayjs from "dayjs";
const { Title } = Typography;

const Questions = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { questions } = useSelector((state) => state.questions);
  const [formattedQuestions, setFormattedQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchedResults, setSearchedResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  // const [page, setPage] = useState(1)
  // const [nexUrl, setNexUrl] = useState('');
  // const [prevUrl, setPrevUrl] = useState('');
  const [totalResult, setTotalResult] = useState(0)

  useEffect(() => {
    if (searchValue && searchValue?.trim()?.length > 0) {
      let copy = [...formattedQuestions];
      copy = copy.filter((el) => {
        return el?.text?.includes(searchValue);
      });
      setSearchedResults(copy);
    } else {
      setSearchedResults([]);
    }
  }, [searchValue]);

  useEffect(() => {
    if (questions?.length) {
      const formatted = questions.map((item) => {
        return {
          ...item,
          key: item?._id,
        };
      });
      setFormattedQuestions(formatted);
    } else {
      setFormattedQuestions([]);
    }
  }, [questions]);

  const getQuestionByPage = async (newPage) => {
    try {
      setLoading(true);
      // let currentPage = newPage;
      // if(!currentPage){
      //   // currentPage = page
      //   currentPage = 1
      // }
      let limit = 3;
      const res = await getQuestions({ page: 1, limit });
      if (res?.data) {
        dispatch(setQuestionsAction(res?.data?.questions));
        // if(res?.data?.next?.url){
        //   setNexUrl(res?.data?.next?.url)
        // }
        // if(res?.data?.previous?.url){
        //   setPrevUrl(res?.data?.previous?.url)
        // }
        // setTotalResult(res?.data?.total)
        openNotification({
          title: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({ id: "doneSuccessfully" }),
          type: "success",
          rtl: true,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openNotification({
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "somethingWentWrong" }),
        type: "error",
        rtl: true,
      });
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "number",
      key: "number",
      width: 80,
      render: (number, record, index) => {
        return <Link to={`${record._id}`}>{index + 1}</Link>;
      },
    },
    {
      title: intl.formatMessage({ id: "question" }),
      dataIndex: "text",
      key: "text",
      width: 300,
      render: (text, record) => {
        return <Link to={`${record._id}`}>{text}</Link>;
      },
    },
    {
      title: 'التاريخ',
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => {
        return <span>{dayjs(createdAt).format('YYYY-MM-DD')}</span>;
      },
      sorter: (a, b) => dayjs(a.createdAt).unix() - dayjs(b.createdAt).unix(),
    }

  ];

  return (
    <div className='tables-card-container' style={{ position: "relative" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // marginBottom: 10,
        }}
      >
        <Title
          level={4}
          style={{
            margin: 0,
          }}
        >
          {intl.formatMessage({ id: "questionsBank" })}
        </Title>
        <Link
          to='/add-text'
          style={{
            margin: 0,
            backgroundColor: COLORS.darkGray,
            color: COLORS.black,
            padding: "5px 10px",
            display: "flex",
            alignItems: "center",
            borderRadius: 5,
          }}
        >
          <BsPlus size={20} />
          {intl.formatMessage({ id: "addNewText" })}
        </Link>

        <Link
          to='/add-question'
          style={{
            margin: 0,
            backgroundColor: COLORS.primary,
            color: COLORS.white,
            padding: "5px 10px",
            display: "flex",
            alignItems: "center",
            borderRadius: 5,
          }}
        >
          <BsPlus size={20} />
          {intl.formatMessage({ id: "addNewQuestion" })}
        </Link>
       
      </div>
      <div>
        <CustomButton
          text={intl.formatMessage({ id: "refresh" })}
          onClick={getQuestionByPage}
          style={{ marginRight: 10 }}
          // icon={<ReloadOutlined />}
          type='text'
        />
      </div>
      <Spin spinning={loading}>
        <div
          style={{
            backgroundColor: COLORS.white,
            marginTop: 40,
            marginRight: "auto",
            marginLeft: "auto",
            borderRadius: 10,
            padding: "20px 5px 0px 5px",
          }}
          className='light-shadow'
        >
          <Table
            searchableProps={{
              debounce: true,
              fuzzySearch: true,
              inputProps: {
                placeholder: "Search this table",
                prefix: <SearchOutlined />,
                disabled: loading || formattedQuestions?.length === 0,
                onChange: (e) => {
                  setSearchValue(e.target.value);
                },
                value: searchValue,
              },
            }}
            columns={columns}
            style={{ borderRadius: 10 }}
            dataSource={formattedQuestions}
            pagination={{
              // pageSize: 3,
              pageSizeOptions: [3,5,10, 50, 100, 200, 500, 1000],
              showSizeChanger: true,
            }}
            // pagination={{
            //   pageSize: 3,
            //   current: page,
            //   total: totalResult,
            //   showSizeChanger: false,
            // }}
            // onChange={(pagination) => {
            //   setPage(pagination.current)
            //   console.log(pagination)
            //   getQuestionByPage(pagination.current)
            // }}
            // scroll={{ x: 500 }}
            // pagination={false}
          />
        </div>
      </Spin>
    </div>
  );
};

export default Questions;
